// DS: i3.1
// from Vlada
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const CloseSmall: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" viewBox="0 0 18 18">
      <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth="2">
        <path d="M1 17L17 1 1 17zM17 17L1 1l16 16z" />
      </g>
    </svg>
  </IconWrap>
);
CloseSmall.displayName = 'CloseSmall';

export default CloseSmall;
